<template>
    <div>
        <div class="kit__utils__heading">
            <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
        <div class="card">
            <div class="card-header card-header-flex">
                <div class="d-flex flex-column justify-content-center mr-auto">
                <h5 class="mb-0"></h5>
                </div>
                <div class="d-flex flex-column justify-content-center">
                    <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">เพิ่มข้อมูลพนักงาน</a>
                </div>
                <div class="d-flex flex-column justify-content-center ">
                <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
                    class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
              </div>
            </div>
            <div class="card-body">
                <tableAdmin @edit-submitted="getFormEditAdmin" @clear-reload="clearReload" @block-submitted="blockAdmin" v-bind="sendDataTable"/>
            </div>
        </div>
        <a-modal v-model="visible" :title="formTitle" footer="">
            <formAdmin @close-form="closeModal" @return-form="submitForm" v-bind="sentDataForm"/>
        </a-modal>
    </div>
</template>

<script>
import tableAdmin from './tableAdmin'
import formAdmin from './formAdmin'
import apiClient from '@/services/api'
export default {
  components: {
    tableAdmin,
    formAdmin,
  },
  data() {
    return {
      formTitle: '',
      visible: false,
      isloading: false,
      formAdminError: false,
      reloadTable: false,
      varidateCheck: [],
      formLayout: 'horizontal',
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      roleAdmin: [],
      form: {
        id: '',
        username: '',
        firstname: '',
        lastname: '',
        phoneNumber: '',
        roleAdminId: '',
        email: '',
        password: '',
        reCheckPassword: '',
      },
      rules: {
        username: [
          { required: true, message: 'กรอก ยูสเซอเนม', trigger: 'blur' },
        ],
        roleAdminId: [
          { required: true, message: 'เลือกสิทธิ์เข้าใช้งาน', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    sentDataForm: function () {
      return {
        form: this.form,
        isloading: this.isloading,
        rules: this.rules,
        roleAdmin: this.roleAdmin,
        formLayout: this.formLayout,
        labelCol: this.labelCol,
        wrapperCol: this.wrapperCol,
        error: this.formAdminError,
        validate: this.varidateCheck,
      }
    },
    sendDataTable: function() {
      return {
        isReload: this.reloadTable,
      }
    },
  },
  methods: {
    showModal(event) {
      var title = (event === 'insert') ? 'เพิ่มข้อมูลพนักงาน' : (event === 'edit') ? 'แก้ไขข้อมูลพนักงาน' : ''

      if (event === 'insert') {
        this.form = {
          id: '',
          username: '',
          firstname: '',
          lastname: '',
          phoneNumber: '',
          roleAdminId: '',
          email: '',
          password: '',
          reCheckPassword: '',
        }
      }
      this.formTitle = title
      this.visible = true

      this.getRoleAdmin()
    },
    refreshData() {
      this.getRoleAdmin()
    },
    handleCancel(e) {
      // console.log('Clicked cancel button')
      this.visible = false
    },
    async getRoleAdmin() {
      this.roleAdmin = []
      await apiClient.get('/roleAdmin', {}).then(response => {
        const res = response.data
        if (res.code === '000') {
          const roleAdin = res.responseData.data

          roleAdin.forEach(element => {
            if (element.status) {
              this.roleAdmin.push(element)
            }
          })
        }
      }).catch(
      //   err => {
      //   // console.log(err)
      // }
      )
    },
    async getAdmin(id) {
      await apiClient.get(`/admin/${id}`, {}).then(response => {
        const res = response.data
        if (res.code === '000') {
          const DataAdmin = res.responseData.data[0]
          this.form = {
            id: DataAdmin.id,
            username: DataAdmin.username,
            firstname: DataAdmin.firstname,
            lastname: DataAdmin.lastname,
            phoneNumber: DataAdmin.phoneNumber,
            roleAdminId: DataAdmin.roleAdminId,
            email: DataAdmin.email,
            password: '',
            reCheckPassword: '',
          }
        }
      }).catch(err => {
        this.notification('error', 'Error', err.message)
      })
    },
    async getFormEditAdmin(id) {
      await this.getAdmin(id)
      this.showModal('edit')
    },
    closeModal() {
      this.visible = false
    },
    notification(type, title, message) {
      this.$notification[type]({
        message: title,
        description: message,
      })
    },
    async submitForm(data) {
      this.isloading = !this.isloading

      const type = (this.formTitle === 'เพิ่มข้อมูลพนักงาน') ? 'POST' : (this.formTitle === 'แก้ไขข้อมูลพนักงาน') ? 'PUT' : ''
      const sentData = {
        username: data.form.username,
        firstname: data.form.firstname,
        lastname: data.form.lastname,
        phoneNumber: data.form.phoneNumber,
        roleAdminId: data.form.roleAdminId,
        email: data.form.email,
        password: data.form.password,
        reCheckPassword: data.form.reCheckPassword,
        banAdmin: false,
      }

      if (type === 'POST') {
        await apiClient.post('/admin/', sentData).then(response => {
          this.isloading = !this.isloading
          // this.loading = false
          if (response.data.code === '000') {
            this.clearReload()
            this.notification('success', 'Success', response.data.message)
            this.visible = false
          } else {
            this.setErrorForm(response.data.responseData, response.data.message)
            this.notification('error', 'Error', response.data.message)
          }
        }).catch(err => {
          this.notification('error', 'Error', err.message)
        })
      } else if (type === 'PUT') {
        sentData.banAdmin = null
        await apiClient.put(`/admin/${data.form.id}`, sentData).then(response => {
          this.isloading = !this.isloading
          if (response.data.code === '000') {
            this.clearReload()
            this.notification('success', 'Success', response.data.message)
            this.visible = false
          } else {
            this.setErrorForm(response.data.responseData, response.data.message)
            this.notification('error', 'Error', response.data.message)
          }
        }).catch(err => {
          this.notification('error', 'Error', err.message)
        })
      }
    },
    setErrorForm(responseData, message) {
      if (responseData.varidateCheck) {
        this.formAdminError = !this.formAdminError
        this.varidateCheck.message = message
        this.varidateCheck.validate = responseData.varidateCheck
      }
    },
    async blockAdmin(result) {
      const sentData = {
        username: result.username,
        firstname: result.firstname,
        lastname: result.lastname,
        phoneNumber: result.phoneNumber,
        roleAdminId: result.roleAdminId,
        email: result.email,
        password: '',
        reCheckPassword: '',
        banAdmin: !result.banAdmin,
      }

      await apiClient.put(`/admin/banAdmin/${result.id}`, sentData).then(response => {
        if (response.data.code === '000') {
          this.clearReload()
          this.notification('success', 'Success', response.data.message)
          this.visible = false
        } else {
          this.setErrorForm(response.data.responseData, response.data.message)
          this.notification('error', 'Error', response.data.message)
        }
      }).catch(err => {
        this.notification('error', 'Error', err.message)
      })
    },
    clearReload() {
      this.reloadTable = !this.reloadTable
    },
  },

}
</script>

<style>
.d-flex.flex-column.justify-content-center {
  padding: 3px;
  border-radius: 10%;
}
</style>
